import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-header_title",
  "use": "icon-header_title-usage",
  "viewBox": "0 0 2 10",
  "content": "<symbol viewBox=\"0 0 2 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-header_title\">\n<rect width=\"2\" height=\"10\" rx=\"1\" fill=\"#095540\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol